function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { connectFactory, THEME_CHANNEL } from 'fela-bindings';

import withTheme from './withTheme';

export default connectFactory(Component, createElement, withTheme, _defineProperty({
  renderer: PropTypes.object
}, THEME_CHANNEL, PropTypes.object));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/react-fela/es/connect.js
// module id = 1101
// module chunks = 0